import * as React from "react";
import * as Styles from "./styles/ContainerStyles";
import { Container } from "@material-ui/core";

import CookieContainer from "../information-pages/CookieContainer";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../services/TelemetryService";

function Cookies() {
  const classes = Styles.ContainerStyles();
  return (
    <Container fixed className={classes.container}>
      <CookieContainer />
    </Container>
  );
}

export default withAITracking(reactPlugin, Cookies, "Cookies");
